import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import NoSSR from 'Components/NoSSR';

const SportsBook = loadable(() => pMinDelay(import('./SportsBook'), 300), {
  fallback: <Loading />
});

const AsyncSportsBook = props => {
  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <NoSSR onSSR={ <Loading /> }>
        <SportsBook { ...props } />
      </NoSSR>
    </ApplicationLayout>
  );
};

AsyncSportsBook.propTypes = {
  userAgent: PropTypes.object,
  match: PropTypes.object
};

export default AsyncSportsBook;
